<div class="app-wrap" dir="ltr" [ngClass]="{ 'mobile-mode' : mobileModeService.isMobileMode() }">
  <div class="app-header" [ngClass]="{ scrolling }">
    <div class="content">
      <div class="res-container">
        <div class="app-header-nav">
          <div class="app-header-brand"><img src="assets/IDEMIA_Public_Security_3L_RGB.png" alt="IDEMIA Public Security"></div>
          @if (isReady) {
            <div class="app-header-logo">
              <img [src]="'assets/alix-logo.png'" alt="Alix Logo">
            </div>
            <div class="app-header-tenant">
              @if (logo()) {
                <img [src]="'assets/' + logo()" alt="Logo">
              }
            </div>
            <div class="app-header-menu-container" [ngClass]="{'toggle-menu-mobile': toggleMenuMobile()}">
              @if (remoteConfig.get('claims_enabled') === 'true') {
                <button mat-button
                  [ngClass]="{ selected: (currentRouteName() || '').startsWith('claims') }"
                  (click)="goTo('claims')" (keydown.enter)="goTo('claims')" tabindex="0"
                >
                  <mat-icon fontSet="material-icons-outlined">record_voice_over</mat-icon>
                  {{ 'CLAIMS' | translate }}
                </button>
              }
              <button mat-button
                [ngClass]="{ selected: (currentRouteName() || '').startsWith('untagged-baggages-search') }"
                (click)="goTo('untagged-baggages-search')" (keydown.enter)="goTo('untagged-baggages-search')" tabindex="0"
              >
                <mat-icon fontSet="material-symbols-outlined">checked_bag</mat-icon>
                {{ 'HOT_SEARCH' | translate }}
              </button>
              <button mat-button
                [ngClass]="{ selected: (currentRouteName() || '').startsWith('untagged-baggages-inventory') }"
                (click)="goTo('untagged-baggages-inventory')" (keydown.enter)="goTo('untagged-baggages-inventory')" tabindex="0"
              >
                <mat-icon fontSet="material-symbols-outlined">checked_bag_question</mat-icon>
                {{ 'STORAGE_INVENTORY' | translate }}
              </button>
              <button mat-button
                [ngClass]="{ selected: (currentRouteName() || '').startsWith('tagged-baggages') }"
                (click)="goTo('tagged-baggages')" (keydown.enter)="goTo('tagged-baggages')" tabindex="0"
              >
                <mat-icon fontSet="material-symbols-outlined">work_update</mat-icon>
                {{ 'SORTED_LUGGAGE_VIEW' | translate }}
              </button>
              @if (remoteConfig.get('tablet_page') === 'true') {
                <button mat-button
                  [ngClass]="{ selected: currentRouteName() === 'tablet' }"
                  (click)="goTo('tablet')" (keydown.enter)="goTo('tablet')" tabindex="0"
                >
                  <mat-icon fontSet="material-symbols-outlined">tablet</mat-icon>
                  {{ 'LUGGAGE_PHOTO' | translate }}
                </button>
              }
            </div>
            <span class="flex-grow"></span>
            <button mat-button
              [ngClass]="{
                selected: this.translate.getCurrentLang() === 'fr-FR' || (!this.translate.getCurrentLang() && this.translate.getFallbackLang() === 'fr-FR')
              }"
              class="trad mat-density--3" (click)="useLangage('fr-FR')" (keydown.enter)="useLangage('fr-FR')" tabindex="0"
            >
              <span class="flag flag-fr"></span>
              FR
            </button>
            <button mat-button
              [ngClass]="{
                selected: this.translate.getCurrentLang() === 'en-GB' || (!this.translate.getCurrentLang() && this.translate.getFallbackLang() === 'en-GB')
              }"
              class="trad mat-density--3" (click)="useLangage('en-GB')" (keydown.enter)="useLangage('en-GB')" tabindex="0"
            >
              <span class="flag flag-uk"></span>
              EN
            </button>
            @if(mobileModeService.isMobileMode()) {
              <button mat-icon-button
                (click)="triggerMobileMenu()"
                (keydown.enter)="triggerMobileMenu()" tabindex="0">
                <mat-icon fontSet="material-symbols-outlined">menu</mat-icon>
              </button>
            }
          }
        </div>
      </div>
    </div>
  </div>

  <div class="app-progress" [ngClass]="{ scrolling }">
    @if (appLoading.loading()) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </div>

  <div class="app-content" [ngClass]="{ 'app-scrolling': scrolling }">
    @if (isReady) {
      <div class="res-container">
        <router-outlet></router-outlet>
      </div>
    }
  </div>
</div>
